module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464176"
    }
  }, [_vm._v("Capítulo 1")])]), _c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464176"
    }
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])])]), _c('p', {
    staticClass: "section-break"
  }, [_c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464176"
    }
  }, [_vm._v("––––––––")])]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464176"
    }
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464176"
    }
  }, [_c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-o"
  }, [_vm._v("O")]), _vm._v(" prédio da Sterling")]), _vm._v(" Investment Tower pairava ameaçadoramente sobre ela, lançando uma sombra escura sobre as pessoas abaixo dela. Bethany Walker estremeceu apesar do calor do dia. Seu coração estava na garganta. Voltar ao Banco de Investimentos Sterling era algo que ela havia jurado nunca mais fazer. Agora ela estava prestes a quebrar essa promessa. Quebrá-la e entrar no lugar que havia causado tanta destruição.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Endireitando os ombros, ela se obrigou a marchar pelas portas de vidro. Ela parou em um dos balcões na entrada e colou um grande sorriso falso em seu rosto.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A secretária da recepção retribuiu o sorriso e a cumprimentou calorosamente.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oi, meu nome é Bethany Walker. Estou aqui para ver o Sr. Sterling,” Bethany disse.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Qual Sr. Sterling?” A secretária perguntou.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("É claro. Ela teria que ser mais específica. Que Bethany soubesse, havia pelo menos cinco Sr. Sterlings. O Sterling que ela tinha que ver imediatamente era o único com o poder de esmagar seu coração em pó. Como ele havia feito muitas semanas atrás.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sua boca ficou seca. A pobre secretária não fazia ideia de todos os pensamentos irascíveis que passavam pela sua cabeça naquele momento e não seria justo ser nada além de cortês. Ela pigarreou. “Kirk. Kirk Sterling.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Um momento, por favor.” A secretária pegou o telefone em sua mesa. “Ele está esperando por você esta manhã?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Não.” Bethany sentiu a garganta entupir de emoção ao se lembrar da maneira como Kirk lhe deu as costas. “Ele não está.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("O comportamento convidativo da secretária ficou frio enquanto ela fazia uma careta de desaprovação. “Sinto muito, mas temos uma política rígida no Banco de Investimentos Sterling. Todas as reuniões com o Sr. Sterling devem ser agendadas.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ele me conhece,” ela deixou escapar. “Kirk e eu somos...” Seu coração apertou tão dolorosamente contra suas costelas que ela teve que fazer uma pausa. O que ela e Kirk eram um para o outro? Inimigos? Conhecidos? Ex-amantes? Talvez eles fossem todas essas coisas. Talvez eles não fossem nada. “Nós trabalhamos juntos no passado,” ela finalmente disse.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Talvez você possa deixar uma mensagem comigo para que eu possa entregá-la a ele,” a secretária disse. “Eu lhe asseguro que irei entregar a mensagem pessoalmente.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Não. Isso era importante demais para deixar como uma mensagem com uma desconhecida. O assunto era delicado demais para simplesmente permitir que qualquer um ficasse sabendo. Mas se não desse algo à secretária, sem dúvida haveria resistência e ela seria impedida de ver Kirk.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Este é um assunto particular,” Bethany murmurou. “Um que pode afetar a reputação do banco.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh.” Os olhos da secretária se estreitaram desconfiados. “Você não é uma repórter, é?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Não. Com certeza não sou,” ela respondeu, sua voz vacilando enquanto seu nervosismo a derrotava. “Você poderia entrar em contato com ele e informar que eu estou aqui? Esta é uma emergência e tenho certeza de que ele vai querer me ver.” Ela não tinha tanta certeza disso, é claro. Depois que Kirk a tirou da prisão e a deixou no apartamento dela, ela não o tinha visto. Pelo menos, não de perto. Havia uma história sobre um evento beneficente glamuroso no noticiário local e ela o viu na TV. Fora isso, ela não tinha posto os olhos em Kirk há semanas.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Talvez seja melhor se você ligar para o Sr. Sterling e agendar você mesma uma reunião. Já que é tão próxima dele, você deve ter o seu número.” A secretária a avaliou com cautela, sem dúvida tentando descobrir a natureza do relacionamento entre eles. Pela maneira como seus lábios se apertaram em desaprovação, ficou claro que a secretária acreditava que Bethany fosse uma espécie de amante desprezada. O que ela era. De certa maneira. Ela havia sido abandonada. Mas nunca viria aqui para perturbar a paz de Kirk.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Apesar de ter assumido o sobrenome de sua mãe, ela também era uma Livingston. E como uma Livingston, ela tinha dignidade demais para fazer o papel da ex perseguidora, por mais devastada que estivesse por Kirk ter terminado com ela.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Deixei mensagens de voz em seu telefone,” Bethany mentiu. Não adiantava dizer à secretária que Kirk provavelmente não atenderia suas ligações, mesmo que ela as tivesse feito. Seu único contato com Kirk foi através do advogado que ele pagou para lidar com sua prisão há várias semanas. O advogado a instruiu a ligar para seu escritório de advocacia se ela tivesse qualquer outro problema jurídico, mas ela não estava com esse tipo de problema. Pelo menos, não no momento.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Bem, não posso prometer nada, mas vou ligar para ele. Mesmo assim, duvido que ele queira ser interrompido, já que está muito ocupado esta semana.” A secretária bateu os dedos no teclado e fez uma pausa enquanto a ligação era completada. “Aqui é a recepção. O Sr. Sterling está disponível? Sim, vou aguardar a transferência.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Bethany mordeu o lábio inferior enquanto esperava os sessenta segundos mais excruciantes de sua vida.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sr. Sterling? Sim, aqui é a recepção. Há uma Bethany Walker aqui para vê-lo.” A secretária ficou em silêncio por um instante e em seguida assentiu. “Ela diz que é uma emergência de natureza delicada. Com certeza, senhor. Até logo.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A secretária desligou. “Sr. Sterling irá vê-la em seu escritório. Você sabe onde fica?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Betânia assentiu. Embora não tivesse visitado a sede do BIS com frequência quando seu pai administrava o banco, ela conhecia muito bem o layout do prédio. Além disso, ela já tinha estado no escritório de Kirk antes. Eles até brincaram em seu escritório em uma ocasião. Calor subiu pelas suas bochechas com a lembrança de quão íntimos eles tinham sido naquela época. “Sim, posso encontrar meu caminho até lá.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mal conseguindo acreditar em sua sorte, ela se despediu rapidamente da secretária e correu para o elevador. Ela tinha que chegar ao escritório de Kirk antes que ele mudasse de ideia ou ordenasse que a segurança a expulsasse. Por mais desesperada que precisasse vê-lo, ela não tinha imaginado que seria tão fácil fazê-lo se encontrar com ela.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando saiu do elevador, ela seguiu pelo corredor, parando na mesa da sua assistente do lado de fora do seu escritório.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sua assistente ergueu os olhos do laptop. “Bethany, certo?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ela assentiu. “Sim.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Você pode entrar imediatamente,” a assistente disse com um aceno de mão.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Agarrando a alça de sua bolsa para se fortalecer, Bethany deu um suspiro profundo e se dirigiu para a porta do escritório de Kirk. Ela colocou a mão na maçaneta por um segundo para se preparar. Então ela endireitou as costas e entrou.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~*~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-k"
  }, [_vm._v("K")]), _vm._v("irk estava parado")]), _vm._v(" na frente das janelas do escritório, as mãos enfiadas nos bolsos enquanto olhava para a rua abaixo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Você está aqui,” ele disse sem se virar para encará-la.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A maneira como ele falou com tanta naturalidade a fez se perguntar se ele a estava esperando. Mas como isso poderia ser possível? Ela não sabia que passaria pelo escritório dele até ontem à noite.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Seu estômago contraiu quando seu olhar pousou sobre ele.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sua estrutura volumosa parecia dominar o amplo escritório, fazendo tudo parecer pequeno comparado a ele. Embora não pudesse ver a expressão em seu rosto, ele ainda tinha uma presença imponente. Ele era alto, com ombros largos, irradiando um ar de poder sob aquele terno caro e elegante que ele estava vestindo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sim. Estou.” Foi a única coisa que ela conseguiu pensar em dizer dadas as circunstâncias.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando ele se virou para olhar para ela, ela teve que se obrigar a respirar. Ela quase tinha esquecido quão bonito ele era. Com cabelos escuros que caíam sobre olhos verdes hipnotizantes, ele tinha a aparência de uma estrela de cinema. O bronzeado saudável e a mandíbula esculpida só acentuavam sua boa aparência.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“O que a traz aqui?” Não era uma pergunta. Não havia nenhuma curiosidade aqui. Nada da preocupação cuidadosa que ele lhe dedicou quando se reuniram depois que ele perdoou todas as suas mentiras. Isso era uma exigência. A demanda do vice-presidente de uma das instituições financeiras mais importantes do mundo. Havia impaciência em seu tom. Rejeição em seus olhos.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Isso partiu seu coração já despedaçado mais uma vez. Nitidamente, Kirk não sentiu tantas saudades dela quanto ela sentiu dele. Pior, era mais provável que ele sequer tivesse sentido saudades dela.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ela chorou muito depois que ele a abandonou abruptamente. Chorou durante dias. Então, depois que o choro parou, ela andou por aí em um torpor confuso. A dor por ele tê-la abandonado foi tão grande que seu corpo entrou em uma espécie de estado de choque protetor e entorpecido. Vê-lo agora era como ter um balde de água gelada jogado sobre ela. O choque entorpecido agora estava sendo substituído por uma dor cortante e arrepiante.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Preciso da sua ajuda.” Mais uma vez. Durante toda a sua vida adulta, ela tinha sido obrigada a se virar. Obrigada a cuidar de si mesma porque ninguém mais iria. Mas então ela conheceu Kirk e se viu se apoiando nele. Ainda mais surpreendente, na maior parte do tempo desde que ela o conheceu, ele queria que ela se apoiasse nele. Ele havia ficado feliz com isso. Como um cavaleiro de armadura brilhante que tinha vindo para carregar seus fardos. Até que ele a deixou em seu apartamento e lhe disse para nunca mais entrar em contato com ele.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Essa era uma ordem que ela tinha pretendido seguir ao pé da letra. No entanto, as últimas doze horas tinham mudado tudo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Com o quê?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Com o coração batendo forte no peito, ela deu vários passos em direção a ele, sem se intimidar com a indiferença em seus olhos. “Ainda estou investigando o desfalque.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ele franziu o cenho. “Ainda tentando limpar o nome do seu pai, você quer dizer.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ela se irritou com o julgamento em seu tom. Embora as coisas que ela tinha descoberto recentemente estivessem testando sua determinação, ela ainda acreditava na inocência de seu pai. As coisas com seu pai estavam mais tensas do que nunca, mas ela tinha que acreditar nele.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Há dez anos, seu pai havia sido preso por fraude financeira e apropriação indevida. Como o rico presidente do Banco Livingston, seu pai havia supervisionado quantias inacreditáveis de dinheiro durante sua carreira. Mas ela sempre se beneficiou de sua própria riqueza pessoal que ele havia herdado de seus pais. Riqueza que ele havia cultivado com seu trabalho como chefe do Banco Livingston. O que significava que ele não poderia ter tido um motivo para defraudar as pessoas de sua riqueza adquirida a duras penas. A acusação nunca havia feito sentido para ela. Não que a mídia ou o sistema de justiça tivessem se importado. Privando-se de um julgamento que poderia ter provado sua inocência, seu pobre pai havia feito um acordo judicial e passado uma década na prisão. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sim. Eu acredito no meu pai. Mesmo que ninguém mais acredite,” ela disse com queixo levantado em desafio. Ela não ia deixar transparecer que suas palavras a estavam afetando. Como ela poderia lhe dizer que começaram a surgir dúvidas sobre seu pai?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Uma década sem seu pai tinha sido um pesadelo. Um pesadelo agravado pelo fato de os pais de Kirk terem sido responsáveis ​​pela prisão de seu pai. Os Sterlings e os Livingstons estavam em conflito mesmo antes da queda de seu pai e seu relacionamento secreto com Kirk só fez as tensões reacenderem. Eles haviam sido inimigos, em lados opostos em uma guerra que as famílias travavam há anos. No início, ela tinha sido totalmente leal ao pai. Tão leal que havia planejado derrubar Kirk com o resto de sua família. Esse plano mudou quando ela começou a se apaixonar por Kirk. Ao conhecê-lo, ela desenvolveu sentimentos profundos por ele. Sentimentos que ela não podia ignorar, por mais que tentasse. Eles foram forçados a se encontrar em segredo por causa da rixa, mas quando suas famílias descobriram a verdade, Kirk terminou abrupta e dolorosamente as coisas entre eles para mantê-la a salvo da ira de seus pais.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Seu pai acredita em você?” Kirk perguntou. “Ele perdoou você pelo... que aconteceu entre nós?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("O lábio inferior dela tremeu. “Não. Ele não perdoou.” Eles nem estavam se falando. Logo depois que Kirk terminou tudo, seu pai se mudou de seu apartamento. Embora ele estivesse morando agora com seu irmão, ela não tinha visto nenhum dos dois desde a mudança. Pior ainda, embora seu irmão falasse com ela ao telefone de vez em quando, seu pai não havia ligado ou enviado uma mensagem. Era como se ela tivesse se tornado invisível. Seu pai a deserdou, e parecia que ele estava permanecendo fiel a essa decisão, apesar de seu rompimento com Kirk.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Lloyd Livingston sempre foi um tolo,” ele retrucou.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Isso não importa. Não vim aqui para que você aprove meu pai.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Para que você veio, então?” ele perguntou.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ela respirou fundo. Suas pernas tremiam à medida que a ansiedade tomava conta dela. Era agora ou nunca. “Vim solicitar os registros financeiros do BIS.” Bethany semicerrou os olhos para que ele soubesse que ela estava falando sério. “De vinte anos atrás.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26481a34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c007.vue
// module id = 78
// module chunks = 0